import { UtilsService } from './../utils.service';
import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { AlertController,LoadingController, Platform } from '@ionic/angular';
import { async } from 'rxjs/internal/scheduler/async';
import validator from 'validator';
import moment from 'moment';
import { Router } from '@angular/router';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

/* Componente de formulario */
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

/* Importación de constantes */
import * as GENERAL from '../constants/general';

export class CatForum {
  constructor(
    public id?: number,
    public forum?: string,
  ) { }
}

export class CatMachine {
  constructor(
    public id?: number,
    public machine?: string,
  ) { }
}

@Component({
  selector: 'app-registro',
  templateUrl: './registro.page.html',
  styleUrls: ['./registro.page.scss', '../../assets/scss/styles.scss']
})
export class RegistroPage implements OnInit {
  bandera = false;

  public listStates = GENERAL.STATE_LIST;
  public catForums: CatForum[];
  public catMachines: CatMachine[];

  /* Variables encargadas del almacenamiento del formulario */
  public registerForm  : FormGroup;
  public nameUser      : AbstractControl;
  public lastNameP     : AbstractControl;
  public lastNameM     : AbstractControl;
  public userEmail     : AbstractControl;
  public userPassword  : AbstractControl;
  public userPasswordC : AbstractControl;
  public gender        : AbstractControl;
  public birthdate     : AbstractControl;
  public state         : AbstractControl;
  public workPlace     : AbstractControl;
  public phoneNumber   : AbstractControl;
  public typeMachine   : AbstractControl;
  public interests     : AbstractControl;
  public invitationCode  : AbstractControl;
  isWeb:boolean = false;
  

  /* CheckBox */
  public checked: AbstractControl;;

  constructor( public services: ServiceService,
               public alertController: AlertController,
               private router: Router,
               private form: FormBuilder,
               public utils: UtilsService,
               private loadingController: LoadingController,
               private firebaseAnalytics: FirebaseAnalytics,
               private platform: Platform
                ) {
    //
    this.isWeb = this.platform.is('desktop');
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Registro");

    this.registerForm = this.form.group({
      nameUser      : ['', Validators.compose( [Validators.required, Validators.pattern('^[A-Z a-z]{1,20}') ] ) ],
      lastNameP     : ['', Validators.compose( [Validators.required, Validators.pattern('^[A-Z a-z]{1,20}') ] ) ],
      lastNameM     : ['', Validators.compose( [Validators.required, Validators.pattern('^[A-Z a-z]{1,20}') ] ) ],
      userEmail     : ['', Validators.compose( [Validators.required, Validators.email ] ) ],
      userPassword  : ['', Validators.compose( [Validators.required, 
                                                Validators.minLength(8), 
                                                Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/) ] ) ],
      userPasswordC : ['', Validators.compose( [Validators.required, 
                                                Validators.minLength(8), 
                                                Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/) ] ) ],
      birthdate     : ['', Validators.required ],
      state         : ['', Validators.required ],
      workPlace     : ['', Validators.compose( [ Validators.maxLength(255) ] ) ],
      phoneNumber   : ['', Validators.compose( [ Validators.maxLength(255) ] ) ],
      typeMachine   : ['', Validators.required ],
      interests     : ['', Validators.required ],
      invitationCode: ['', Validators.compose( [ Validators.maxLength(10) ] ) ],
      checked       : ['', Validators.required ],
    });

    this.nameUser      = this.registerForm.controls.nameUser;
    this.lastNameP     = this.registerForm.controls.lastNameP;
    this.lastNameM     = this.registerForm.controls.lastNameM;
    this.userEmail     = this.registerForm.controls.userEmail;
    this.userPassword  = this.registerForm.controls.userPassword;
    this.userPasswordC = this.registerForm.controls.userPasswordC;
    this.birthdate     = this.registerForm.controls.birthdate;
    this.state         = this.registerForm.controls.state;
    this.workPlace     = this.registerForm.controls.workPlace;
    this.phoneNumber   = this.registerForm.controls.phoneNumber;
    this.typeMachine   = this.registerForm.controls.typeMachine;
    this.interests     = this.registerForm.controls.interests;
    this.invitationCode = this.registerForm.controls.invitationCode;
    this.checked       = this.registerForm.controls.checked;
  }

  ngOnInit() {
    this.getCatForums();
    this.getCatMachines();
  }

  async getCatForums() {
    (await this.services.getCatForums()).subscribe(
      (data) => {
        this.catForums = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async getCatMachines() {
    (await this.services.getCatMachines()).subscribe(
      (data) => {
        this.catMachines = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public updateCheck() {
  }

  async registerUser() {
    this.onSubmit();
  }

  async onSubmit() {
    if ( this.userPassword.value === this.userPasswordC.value ) {
      let message:string = '';
      if(!this.nameUser.value){
        message = "Falta llenar el campo 'Nombre'";
      }else if(!this.lastNameP.value){
        message = "Falta llenar el campo 'Apellido paterno'";
      }else if(!this.lastNameM.value){
        message = "Falta llenar el campo 'Apellido materno'";
      }else if(!this.birthdate.value){
        message = "Falta llenar el campo 'Fecha de nacimiento'";
      }else if(!this.userEmail.value){
        message = "Falta llenar el campo 'Correo Electrónico'";
      }else if(!this.userPassword.value){
        message = "Falta llenar el campo 'Contraseña'";
      }else if(!this.state.value){
        message = "Falta seleccionar un estado";
      }else if(!this.workPlace.value){
        message = "Si no trabajas en ninguna empresa, escribe alguna de estas opciones: <b>Estudiante, Trabajador independiente, otro.</b>";
      }else if(!this.phoneNumber.value){
        message = "Falta llenar el campo 'Número de teléfono";
      }else if(!this.typeMachine.value){
        message = "Seleccione algún tipo de máquina que utilices";
      }else if(!this.interests.value){
        message = "Seleccione algún interés";
      }
      if(message){
        const alert = await this.alertController.create({
          header: "Complete campo faltante",
          subHeader: "",
          message: message,
          buttons: ["OK"],
        });
        await alert.present();
        return;
      }

      const loading = await this.loadingController.create({
        message: 'Registrando espere...'
      });
      await loading.present();

      this.bandera = false;

      const params = {
        "email": this.userEmail.value,
        "password": this.userPassword.value,
        "name": this.nameUser.value,
        "lastName": this.lastNameP.value,
        "secondLastName": this.lastNameM.value,
        "birthdate": this.birthdate.value,
        "stateId": this.state.value,
        "workPlace": this.workPlace.value,
        "phoneNumber": this.phoneNumber.value,
        "relUsersInterestsData": this.interests.value,
        "relUsersMachinesData": this.typeMachine.value,
        "friendCode": this.invitationCode.value
      }

      await this.services.register(params).subscribe(async data => {
         if (data['susseful'] === 1) {
           console.log("if (data['susseful'] === 1");
           loading.dismiss();
           const alert = await this.alertController.create({
             header: 'Registro cuenta',
             subHeader: '',
             message: data['mensaje'],
             buttons: ['OK'],
           });
           await alert.present();
           await alert.onDidDismiss();
           this.router.navigate(["/login"]);
         }
         console.log("linea 78");
       },
         async error => {
           loading.dismiss();
           let mensage = "Por favor intenta de Nuevo";
             switch(error.status){
               case 400:
               case 403:
               case 401:
               case 500:
                 mensage = error.error;
                 break;
             }
             const alert = await this.alertController.create({
               header: "",
               subHeader: "",
               message: mensage,
               buttons: ["OK"],
             });

           await alert.present();
           await alert.onDidDismiss();
         },
       );
    } else {
      this.bandera = true;
    }
  }

  home() {
    this.router.navigate(['/']);
  }


checkData($event){
  
  let regex = /^([0-9]+)$/g; 
  let key = $event.detail.value;
  
  if(!regex.test(key) && key != ""){
    let newVal = String(key).replace(/[^\d]/g, '');
    $event.target.value = newVal;
    this.registerForm.controls['phoneNumber'].patchValue(newVal);

  }
  
}


}
